import React from 'react';
import { SettingAssetContextValue } from './assetInterface';

export const SettingAssetContext = React.createContext<SettingAssetContextValue | null>(
    null
);
